import request from 'tools/request'
import { DocumentListResponse, DocumentResponse, UpdateDocumentRequest, UploadDocumentParams } from 'types/document'
import { PAGINATION_LIMIT_VALUE_NUM, PAGINATION_NUM_VALUE_NUM } from 'constants/headers'
import { getPaginationHeaders } from 'tools/headers'

export const uploadDocument = async (file: File, params?: UploadDocumentParams) => {
  const formData = new FormData()
  formData.append('file', file)
  const data = await request
    .post<DocumentResponse>('documents', formData, {
      params: params,
    })
    .then((res) => {
      return res.data
    })
  return data
}

export const getDocumentByCompanyId = async (
  companyId: string,
  active: string | null,
  pageNumber: number = PAGINATION_NUM_VALUE_NUM,
  pageLimit: number = PAGINATION_LIMIT_VALUE_NUM,
  sort: string,
  type: string | null,
  documentOtherType: string | null
) => {
  const data = await request
    .get<DocumentListResponse>(`documents`, {
      params: {
        companyId: companyId,
        active: active,
        sort: sort,
        type: type,
        otherType: documentOtherType,
      },
      headers: getPaginationHeaders(pageNumber, pageLimit),
    })
    .then((res) => {
      return { data: res.data, headers: res.headers }
    })
  return data
}

export const getDocumentMetadata = async (documentId: string) => {
  const data = await request.get<DocumentResponse>(`documents/metadata/${documentId}`).then((res) => {
    return res.data
  })
  return data
}

export const updateDocument = async (documentId: string, payload: UpdateDocumentRequest) => {
  const data = await request.put<DocumentResponse>(`documents/${documentId}`, payload).then((res) => {
    return res.data
  })
  return data
}
